export default {
  customInventoryReportslist: {},
  defaultInventoryReport: null,
  customAllProductSalesReportslist: {},
  defaultAllProductSalesReport: null,
  customAllProductPurchaseReportslist: {},
  defaultAllProductPurchaseReport: null,
  customSellerOrderReportslist: {},
  defaultSellerOrderReport: null,
  customBuyerOrderReportslist: {},
  defaultBuyerOrderReport: null,
  customTeamSalesReportslist: {},
  defaultTeamSalesReport: null,
  customPaymentsReportslist: {},
  defaultPaymentsReport: null,
};
